export const ROOT_MENU = 'root';
